import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { HashLink as LinkHash } from 'react-router-hash-link';
import Cookies from 'js-cookie';
import { MEMBER_URL } from '../../constants/Constants';

const MenuMobile = () => {
  const handleMenu = (event) => {
    event.preventDefault();
    const elem = document.querySelectorAll('.menu-container')[0];
    elem.classList.toggle('collapse');
  };

  const handleOutSesion = () => {
    Cookies.remove('jwt_clubpremier');
    window.location.href = `${MEMBER_URL}/salir`;
  };

  const { status } = useSelector((state) => state.user);

  const renderButtonsSessionActive = () => {
    return (
      <div>
        <button type="button" className="btn btn-secondary-dark btn-sm btn-size-override" onClick={handleOutSesion}>
          Cierra sesión
        </button>
      </div>
    );
  };

  const renderButtonsNotSession = () => {
    return (
      <div>
        <a className="btn btn-secondary-dark btn-sm btn-size-override" href={`${MEMBER_URL}/entrar`}>
          Inicia sesión
        </a>
        <a className="btn btn-primary-dark btn-sm btn-size-override" href={`${MEMBER_URL}/registro`}>
          Inscríbete
        </a>
      </div>
    );
  };

  return (
    <div className="nav-menu-responsive d-block d-lg-none d-xl-none">
      <div className="main-bar py-30">
        <div>
          <a className="menu-toggle" href="/" onClick={handleMenu}>
            <i className="fas fa-bars" />
          </a>
        </div>
        {
          status === 'success' ? renderButtonsSessionActive() : renderButtonsNotSession()
        }
      </div>
      <div className="menu-container collapse">
        <div className="menu-content level-1">
          <div className="menu-item">
            <div className="menu-item-label">
              <Link to="/">
                <i className="fas fa-home text-tangaroa" />
              </Link>
            </div>
          </div>
          <div className="menu-item">
            <div className="menu-item-label">
              <Link to="/subastas" className="text-tangaroa">
                Subastas
              </Link>
            </div>
          </div>
          <div className="menu-item">
            <div className="menu-item-label">
              <LinkHash to="/#subastas-recomendadas" className="text-tangaroa">
                Subastas recomendadas
              </LinkHash>
            </div>
          </div>
          <div className="menu-item">
            <div className="menu-item-label">
              <Link to="/ganadores" className="text-tangaroa">
                Ganadores
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuMobile;
